module.exports = __webpack_public_path__ + "static/media/impossible-staircase_banner.d844a137.jpg";